'use client';
import React, { useEffect, useRef, useState } from "react";
import { Auth } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import { createScript, deleteGoogleCredentials, getGoogleCredentialsFromLS, initGsi, isTokenExpired, renderGoogleButton } from "../../load_and_get_google_access_token";
import ClientComponent from "../builder/client_component";
import loginBg_1 from "../../assets/images/loginbg_1.png";
import loginBg_2 from "../../assets/images/loginbg_2.png";
import loginBg_3 from "../../assets/images/loginbg_3.png";
import googleLogo from "../../assets/images/google-logo.png";
import DesignsSlideshowComponent, { DesignerSlideShowData, Slide } from "../designs_slideshow";
import styles from "./login.module.scss";
import '@aws-amplify/ui-react/styles.css';
import awsConfig from "../../utils/aws-config";
import { createFBScript, deleteFBKCredentialsFromLS, getFBKCredentialsFromLS, signInWithFacebook } from "@/utils/load_and_get_facebook_access_token";
import FacebookIcon from '@mui/icons-material/Facebook';
import AppleIcon from '@mui/icons-material/Apple';
import GoogleIcon from '@mui/icons-material/Google';
import { getLoggedInEmailAddress, gtmClickTracking, gtmPageOnloadTracking } from "@/utils";
import { getCurrentBrand, getCustIdFromLS, getUserInfo, removeCustIdFromLS, setCurrentBrand, setDirectCognitoCredentialsIntoLS, getUserTypeFromUrlLs } from "@/utils/useUserInfo";
import { Box, Button, CircularProgress } from "@mui/material";
import { get } from "http";
import nestingaleLogo from "../../assets/images/logo.svg";
import AppleButton from "../popups/AppleButton";
import { appleResponseCallback } from "@/utils/load_and_get_apple_access_token";
import Link from "next/link";
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';
// import { useRouter } from "next/router";
interface LoginComponentProps {
    layerMode?: boolean;
    brand: string;
    loginCallback?: Function;
    isStyleQquiz: boolean;
    hideLayerTitle: boolean;
    setHideLayerTitle?: Function;
    handleDialogClose?: Function;
    refresh?: boolean;
    redirectTo?: string;
}

const formFields = {
    signUp: {
        username: {
            order: 1,
            label: "Email", // Custom label for display
            placeholder: "Enter your Email", // Custom placeholder
            pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        },
        password: {
            order: 5
        },
        confirm_password: {
            order: 6
        }
    },
}


export async function redirectToNextPage(redirectTo: string = "") {

    try {
        //Navigating to next url param using URLSearchParams instead of const { next } = router.query;
        // as router is stale and having old url param values instead of current page
        let cId = getCustIdFromLS()
        try {
            if (!cId) {
                const userInfo = await getUserInfo("", true);
            }
        } catch (e) {
            console.log("Failed to save Google email Address", e)
        }

        let email = getLoggedInEmailAddress();
        cId = getCustIdFromLS()
        if (email && cId) {
            const urlParams = new URLSearchParams(window.location.search);
            let next = urlParams.get('next');
            const nextFromLS = localStorage.getItem('next');
            if (!next && nextFromLS) {
                localStorage.removeItem('next');
                console.log('next from localStorage:', nextFromLS);
                if (nextFromLS) {
                    next = nextFromLS;
                }
            }
            // Ensure 'next' is a relative URL or has the same host
            if (next) {
                try {
                    const nextUrl = new URL(next, window.location.origin);
                    if (nextUrl.origin !== window.location.origin) {
                        next = '';
                    } else {
                        next = nextUrl.pathname + nextUrl.search + nextUrl.hash;
                    }
                } catch {
                    // If next is not a valid URL, allow only relative paths
                    if (!next.startsWith('/')) {
                        next = '';
                    }
                }
            }
            console.log('----------next-------------', next);
            if (redirectTo) {
                window.location.href = redirectTo.replace(/[<>*]/g, '');
            } else if (next) {
                window.location.href = next.replace(/[<>*]/g, '');
            } else if (window.location.pathname.indexOf("/login/designer") > -1) {
                window.location.href = `${getCurrentBrand()}/successconfirmation`;
            } else if ((window.location.pathname.indexOf("/login/customer") > -1
                || (window.location.pathname.indexOf("/login/dc") > -1))) {
                window.location.href = `${getCurrentBrand()}/styleprofile`;
            } else {
                let previousPageUrl = document.referrer;
                if (previousPageUrl && previousPageUrl.indexOf("login") == -1) {
                    window.location.href = previousPageUrl;
                } else {
                    window.location.href = `${getCurrentBrand()}/rooms`;
                }
            }
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    width: '100%'
                }}>
                    <h2>Redirecting, please wait...</h2>
                    <div><CircularProgress size={24} /></div>
                </div>
            )
        }
    } catch (e) { }

}

const LoginComponent: React.FC<LoginComponentProps> = ({ layerMode = false, brand, loginCallback, isStyleQquiz, hideLayerTitle, setHideLayerTitle, handleDialogClose, refresh, redirectTo }) => {
    setCurrentBrand(brand)

    const {
      isInteriorDesigner,
      isProductSupplier,
      isCampaign,
      forDev,
      userType
    } = getUserTypeFromUrlLs();

    // If the user is already logged in, redirect to the next page
    const isAiFlow = isInteriorDesigner || isProductSupplier || isCampaign;

    const [redirecting, setRedirecting] = React.useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const logoImages = [
        { "img": loginBg_1.src, "caption": "" },
        { "img": loginBg_2.src, "caption": "" },
        { "img": loginBg_3.src, "caption": "" }
    ]

    const getAiRedirectUrl = (userType: string): string => {
        if (localStorage.getItem('loginFrom')) {
            const loginFrom = localStorage.getItem('loginFrom');
            localStorage.removeItem('loginFrom');
            try {
                if (loginFrom) {
                    const url = new URL(loginFrom, window.location.origin);
                    if (url.pathname) {
                        redirectTo = url.pathname;
                    }
                }
            } catch (e) {
                console.error("Invalid loginFrom URL in localStorage", e);
            }
        } else {
            if (isCampaign) { // keep this at the top because, user could be either designer or supplier too. 
                redirectTo = "/social/campaign";
            } else if (isInteriorDesigner) {
                redirectTo = "/ai/designer";
            } else if (isProductSupplier) {
                redirectTo = "/ai/supplier";
            } else if (userType === "designer") {
                redirectTo = "/ai/designer";
            } else if (userType === "supplier") {
                redirectTo = "/ai/supplier";
            } else {
                redirectTo = "/ai";
            }
        }
        return redirectTo || "/";
    }


    console.log("LoginComponent...");
    const [isLoaded, setLoaded] = useState(false);
    
    if (typeof window !== 'undefined') {
        //@ts-ignore
        if (!window.FB) {
            createFBScript();
        }
    }

    useEffect(() => {
        if (layerMode) {
            gtmPageOnloadTracking({
                event: 'LoginLayer'
            });
        }
    }, []);


    useEffect(() => {
        //@ts-ignore 
        if (window.nestingale && window.nestingale.triggeredRedirection) {
            setRedirecting(true);
        }
    })
    const prepareDesignerSlideShowData = (images: any): DesignerSlideShowData => {
        const slides: Slide[] = images && images.map((image: any, index: any) => {
            return { id: "design" + index, image: image.img, caption: image.caption } as Slide;
        })
        const carouselSlides = [...slides];
        return { designs: carouselSlides, dispatcher: {}, height: '100vh !important' }
    }

    const appleLoginCallback = (response: any) => {
        console.log("Apple button click callback : " + JSON.stringify(response));
        appleResponseCallback(response, loginCallback);
    }
    async function handleGoogleSignIn() {
        try {
            // Open Google sign-in in a popup window
            // Calculate centered position for popup
            const width = 500;
            const height = 600;
            const left = (window.screen.width - width) / 2;
            const top = (window.screen.height - height) / 2;
            // Add a message listener in parent window(calling this event in child window)
            window.addEventListener('message', async (event) => {
                if (event.data.type === 'AUTH_SUCCESS') {
                    try{
                            let userInfo;
                            try{
                              userInfo = await getUserInfo("",true);
                            }catch(e){
                              console.log("Failed to save Google email Address",e)
                            }
                            if (loginCallback) {
                                loginCallback({type: "google", userInfo: userInfo, status: "LOGIN_SUCCESS"});
                            } else if(refresh === true){
                                console.log("refreshing the page")
                            } else if (redirectTo) {
                                redirectToNextPage(redirectTo);
                            } else {
                                //@ts-ignore
                                window.nestingale && (window.nestingale.triggeredRedirection = true);
                                redirectToNextPage();
                              }
                        
                    }catch(error){
                        console.log(error)
                    }
                }else if(event.data.type==='AUTH_FAILED'){
                    console.log("Google sign-in failed");
                    //try to restart the application application with clearing localstorage
                    alert("please retry the Google authentication process");
                    localStorage.clear()
                    window.location.reload();

                }
            });
            const signInUrl = `${awsConfig({ protocol: window.location.protocol.split(":")[0], domain: window.location.host }).Auth?.oauth?.domain}/oauth2/authorize?identity_provider=Google&redirect_uri=${encodeURIComponent(window.location.origin + '/auth-callback')}&response_type=code&client_id=${awsConfig({ protocol: window.location.protocol.split(":")[0], domain: window.location.host }).Auth.userPoolWebClientId}&scope=email+openid+profile&prompt=select_account`;
            window.open(
                signInUrl,
                'Google Sign In',
                `width=${width},height=${height},left=${left},top=${top},toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=no`
            );
        } catch (error) {
            console.log('error at login component while signin', error)
        }
    }
    {/*<Authenticator hideSignUp={true} socialProviders={['facebook', 'google']}>
        </Authenticator>*/}



    if (isStyleQquiz && hideLayerTitle) {
        return (
            <Box component="div" className={styles.style_profile_signup}>
                <h3>Sign in to save your style profile, and start designing your dream home</h3>
                <Button sx={{
                    backgroundColor: 'primary.main',
                    color: '#fff',
                    textTransform: 'none',
                    '&:hover': {
                        backgroundColor: 'primary.main' 
                    },
                    margin: '0 auto',
                    display: 'flex',
                    width: '200px'
                }} onClick={() => {
                    if (setHideLayerTitle) {
                        setHideLayerTitle(false);
                    }
                    gtmClickTracking({ 
                        event: 'signin_from_stylequiz_preheat', 
                        action_taken: "sign_in",
                        id: "sign_in_preheat"
                    });
                }}>Sign in</Button>
                <h4>Not now? <Link href={"/shop"} onClick={()=>{
                    gtmClickTracking({ 
                        event: 'signin_from_stylequiz_preheat', 
                        action_taken: "not_now",
                        id: "not_now_preheat" 
                    });
                }}>Browse inspirations!</Link></h4>
            </Box>
        );
    }

    return (
        <>
            {!layerMode &&
                <>
                    <a href="/"><img src={nestingaleLogo.src} alt="Nestingale Logo" className={styles.logo} /></a>
                    <div className={styles["slideshow-container"]}><DesignsSlideshowComponent  {...prepareDesignerSlideShowData(logoImages)} /></div>
                </>
            }
            {
                //@ts-ignore 
                redirecting
                    ? <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        height: '100%',
                        width: '50%'
                    }}>
                        <h2>Please wait...</h2>
                        <div><CircularProgress size="20" /></div>
                    </div>
                    : <div className={styles[layerMode ? "login-layer-container" : "login-left-container"]}>

                        {!layerMode && <h1 className={styles.heading}>Please sign-in or register</h1>}
                         {layerMode && (!isAiFlow) && (
                            <div style={{ textAlign: 'center' }}>
                                <h3 style={{ marginBottom: 0, marginTop: '3px' }}>Pro customer? Sign in as an</h3>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', justifyContent: 'center' }}>
                                    <a style={{ fontWeight: 'bold', cursor: 'pointer', color: '#0D908E' }} target="_blank" href="/interior-designer">Interior Designer</a>
                                    <p style={{ margin: 0 }}>or</p>
                                    <a style={{ fontWeight: 'bold', cursor: 'pointer', color: '#0D908E' }} target="_blank" href="/product-supplier">Product Supplier</a>
                                </div>
                            </div>
                        )}

                        <Authenticator formFields={formFields} signUpAttributes={["address", "gender"]} hideSignUp={isAiFlow && !forDev}>
                        {
                            ({ signOut, user }: any) => {

                                //@ts-ignore
                                if (!(window.nestingale && window.nestingale.triggeredRedirection)) {
                                    // removeCustIdFromLS();
                                    // deleteGoogleCredentials();
                                    // deleteFBKCredentialsFromLS();
                                    (async () => {
                                        try {
                                            let currentCredentials = await Auth.currentCredentials();
                                            if (user?.signInUserSession?.idToken?.payload?.iss?.indexOf("cognito-idp") > -1) {
                                                const userTypeToUse = user?.attributes?.profile || userType || "customer";
                                                setDirectCognitoCredentialsIntoLS({ ...currentCredentials, email: user?.attributes?.email, lastName: user?.attributes?.family_name, name: user?.attributes?.preferred_username || "User" }, userTypeToUse)
                                            }
                                        } catch (e) {
                                            console.error("Error getting current credentials or saving to LS", e);
                                            return;
                                        }

                                        if(user) {
                                            let profileType = user?.attributes?.profile;
                                            if (isAiFlow || ["designer", "supplier"].includes(profileType)) {
                                                localStorage.setItem('ai-user-type', profileType);
                                                if (!window.location.search.includes('next=') || !localStorage.getItem('next')) {
                                                    redirectTo = getAiRedirectUrl(profileType);
                                                }
                                            }
                                        }
                                        if (layerMode && loginCallback) {
                                            loginCallback({ type: "cognito", status: "LOGIN_SUCCESS" });
                                        } else if (redirectTo) {
                                            redirectToNextPage(redirectTo);
                                        } else if (refresh === true) {
                                            console.log("refreshing the page")
                                        } else {
                                            setRedirecting(true);
                                            redirectToNextPage();
                                        }
                                    })()
                                }
                                return (
                                    <main>
                                        {/* <h1>Hello {user?.attributes?.preferred_username || user?.username}</h1> */}
                                        {/* <button onClick={signOut}>Sign out</button> */}
                                    </main>
                                )
                            }}
                        </Authenticator>
                        {
                            !isLoggedIn && (!isAiFlow) && <div className={styles["login_left-section"]}>
                                <div className={styles["google-button-wrapper"]} style={{cursor:'pointer'}} onClick={handleGoogleSignIn} >
                                    <div className={styles["google-button-section"]}>
                                        <div className={styles["custom-google-button"]} >
                                            <img src={googleLogo.src} alt="Google logo" /> <span>Continue with Google</span>
                                        </div>
                                    </div>
                                </div>
                                {/* <div onClick={()=>signInWithFacebook(router)} className={styles.facebook_login}><FacebookIcon sx={{fontSize: '24px'}} /> <span>Sign in with Facebook</span></div> */}
                                <div className={styles["apple_login"]}><AppleIcon sx={{ fontSize: '24px' }} /> <span> <AppleButton appleLoginCallback={appleLoginCallback} /></span></div>
                            </div>
                        }
                        
                    </div>}
        </>
    )
}

export default ClientComponent(LoginComponent);